import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
import moment from 'moment-timezone';

    

    function EndpointDetailFormatter(params, observableOptions) {
        var self = this;

        self.observableOptions = observableOptions;

        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();

        self.isCallControl = params && params.type === "CallControl";
        self.isBridge = params && params.type === "Bridge";

        self.observableFormattedData = ko.observable({});

        self.type = params.type;

        self.subscriptions = [];
    }

    function GetCallQualityData(rtdata, endpointCallData, gridformattercommon, formatterCommon) {
        var result = [];

        _.forEach(_.get(rtdata, 'calls'), function(call) {
            var id = _.get(call, 'id[0].text');
            var list = _.get(endpointCallData, '[' + id + ']');
            var callData = _.last(list);
            if (callData) {
                result.push({
                    name: formatterCommon.getSpanTitle(callData.name),
                    remoteaddr: formatterCommon.getSpanTitle(callData.remoteaddr),
                    calltype: callData.calltype,
                    bitrate: callData.bitrate ? callData.bitrate + " kbps" : "",
                    presentation: formatterCommon.getSpanTitle(callData.presentation),
                    starttime: gridformattercommon.getTimeString(callData.starttime),
                    duration: gridformattercommon.GetDurationString(callData.duration),
                    packetloss: gridformattercommon.getQualityMetricMarkupWithoutUnits(callData.packetlossQualityIndicator, callData.maxPacketloss),
                    jitter: gridformattercommon.getQualityMetricMarkupWithoutUnits(callData.jitterQualityIndicator, callData.maxJitter),
                    details: "<a href='#quality/" + encodeURIComponent(id) + "?nosave=true' title='quality details'>Details</a>"
                });
            }
        });
        return result;
    }

    function getActiveCalls(item, endpointCallData, gridFormatterCommon, formatterCommon, ephistinfo) {
        var hasdetail = item.hasDetail;
        var rtdata;

        var innerheaders = [
            "Display Name", "Dial String", "Call Type", "Call Rate", "Presentation", "Start Time", "Duration",
            "Packet Loss (%)", "Jitter (ms)", "Quality"
        ];
        var innerrows;

        if (hasdetail === "true") {
            rtdata = item.RtData[0];
            innerrows = GetCallQualityData(rtdata, endpointCallData, gridFormatterCommon, formatterCommon);
        }
        else {
            innerrows = [];
        }

        var hasEpHistInfo = ephistinfo && (ephistinfo.length > 0);
        return {
            id: item.id,
            historicalId: hasEpHistInfo ? ephistinfo[0].dimEndpointSID : null,
            name: item.name,
            altName: item.altName,
            maxCount: innerrows.length,
            rows: innerrows,
            rowProperties: ['name', 'remoteaddr', 'calltype', 'bitrate', 'presentation', 'starttime', 'duration', 'packetloss', 'jitter', 'details'],
            headers: innerheaders,
            widths: ['0%', '14%', '9%', '9%', '9%', '11%', '10%', '10%', '8%', '8%', '8%', '4%']
        };

    }

    function getCodecInfo(item, gridFormatterCommon, ephistinfo) {
        if (_.isString(item.dp)) {
            try {
                item.dp = JSON.parse(item.dp);
            } catch (e) {}
        }

        var hasEpHistInfo = ephistinfo && (ephistinfo.length > 0);

        var result = {
            id: item.id,
            name: item.name,
            tags: item.tags,
            tmsTag: item.tmsTag,
            status: gridFormatterCommon.getStatusMarkupForEndpoint(gridFormatterCommon.convertStatusToNumber(item.status)),
            model: item.model,
            serial: item.serialNumber,
            firmware: item.firmware,
            accessInterface: _.get(item, 'dp.portId', ''),
            vlan: _.get(item, 'dp.VLAN', ''),
            category: hasEpHistInfo ? _.get(ephistinfo, '[0].Category', '') : item.subCategory,
            manufacturer: hasEpHistInfo ? _.get(ephistinfo, '[0].Manufacturer', '') : item.manufacturer,
            cucm: item.cucmDeviceName ? item.cucmDeviceName + ' (' + item.dn + ')' : '',
            duplex: _.get(item, 'dp.duplex', ''),
            primaryMgmtAddress: gridFormatterCommon.getLinkWithHost(_.get(item, 'dp.primaryMgmtAddress')),
            description: item.description,
            altName: item.altName,
            location: item.location,
            price: item.price,
            directNumber: item.directNumber,
            sipAddress: item.sipAddress,
            building_city: item.building_city,
            building_country: item.building_country,
            building_key: item.building_key,
            building_name: item.building_name,
            building_region: item.building_region,
            building_site: item.building_site,
            building_state: item.building_state,
            room_endpoint_type: item.room_endpoint_type,
            room_floor: item.room_floor,
            room_id: item.room_id,
            room_name: item.room_name,
            room_type: item.room_type
        };

        result.networkIp = item.host ? gridFormatterCommon.getLinkWithHost( _.escape(item.host) ) : "";
        if (item.solarwindsLink) {
            var solarwindsLink = gridFormatterCommon.getSolarWindsLink("", item.solarwindsLink, false);
            result.networkIp = item.host ? solarwindsLink + "&nbsp;" + result.networkIp : solarwindsLink;
        }

        if (!_.isEmpty(item.AVS)) {
            var hwstatus = gridFormatterCommon.getHwStatusMarkup(item.AVS);
            var hwtokens = hwstatus.split('&nbsp;');
            result.sourceStatus = hwtokens[0];
            result.displayStatus = hwtokens[1];
        }
        return result;
    }

    function ComposeData(formatterCommon, gridFormatterCommon, sourceList, endpointCallData, ephistinfo, options, type) {
        if (_.isEmpty(sourceList) || !options.endpointId) {
            return null;
        }

        var endpoints = _.filter(sourceList, function(epitem) { return ''+epitem.id === options.endpointId; });
        if (_.isEmpty(endpoints)) {
            return null;
        }

        var item = endpoints[0];
        if (type === "Codec") {
            return getCodecInfo(item, gridFormatterCommon, ephistinfo);
        }
        if (type === "ActiveCalls") {
            return getActiveCalls(item, endpointCallData, gridFormatterCommon, formatterCommon, ephistinfo);
        }
        return {};
    }


    EndpointDetailFormatter.prototype.RefreshData = function() {
        var self = this;

        self.observableFormattedData(ComposeData(self.formatterCommon,
            self.gridFormatterCommon,
            self.dataRepository.endpointStatusData(),
            self.dataRepository.endpointCallData(),
            self.dataRepository.endpointHistoricalInfo(),
            self.observableOptions(),
            self.type));
    };

    EndpointDetailFormatter.prototype.DataUpdated = function() {
        var self = this;
        self.RefreshData();
    };

    EndpointDetailFormatter.prototype.OptionsUpdated = function() {
        var self = this;
        self.RefreshData();
    };

    EndpointDetailFormatter.prototype.initialize = function(dataRepository) {
        var self = this;
        self.dataRepository = dataRepository;

        self.subscriptions.push(dataRepository.endpointStatusData.subscribe(function() {
            self.DataUpdated();
        }));
        self.subscriptions.push(dataRepository.endpointHistoricalInfo.subscribe(function(newval) {
            if (newval) {
                  self.DataUpdated();
             }
        }));
        self.subscriptions.push(self.observableOptions.subscribe(function() { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!_.isEmpty(dataRepository.endpointStatusData())) {
            self.RefreshData();
        }
    };

    EndpointDetailFormatter.prototype.getObservableData = function() {
        var self = this;
        return self.observableFormattedData;
    };

    EndpointDetailFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function(sub) {
            sub.dispose();
        });
    };

    export default EndpointDetailFormatter;
